import { buildInteractiveResult, Result } from '@coveo/headless';
import React, { FunctionComponent, useContext, useEffect, PropsWithChildren } from 'react';
import { AppContext } from './engine';
import { filterProtocol } from './filter-protocol';

interface LinkProps extends PropsWithChildren {
	result: Result;
	className?: string;
	tabIndex?: number;
	externalIcon?: boolean;
}

export const ResultLink: FunctionComponent< LinkProps > = ( props ) => {
	const { engine } = useContext( AppContext );
	const url = new URL( props.result.clickUri );
	const isExternal = url.host !== window.location.host;

	const interactiveResult = buildInteractiveResult( engine!, {
		options: { result: props.result },
	} );

	useEffect( () => () => interactiveResult.cancelPendingSelect(), [] );

	return (
		<a
			href={ filterProtocol( props.result.clickUri ) }
			onClick={ () => interactiveResult.select() }
			onContextMenu={ () => interactiveResult.select() }
			onMouseDown={ () => interactiveResult.select() }
			onMouseUp={ () => interactiveResult.select() }
			onTouchStart={ () => interactiveResult.beginDelayedSelect() }
			onTouchEnd={ () => interactiveResult.cancelPendingSelect() }
			className={ props.className }
			tabIndex={ props?.tabIndex ?? 0 }
			target={ isExternal ? '_blank' : '_self' }
		>
			{ props.children }
			{ props.externalIcon && isExternal && (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					width="16"
					height="16"
					aria-hidden="true"
					focusable="false"
				>
					<path
						d="M19.5 4.5h-7V6h4.44l-5.97 5.97 1.06 1.06L18 7.06v4.44h1.5v-7Zm-13 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3H17v3a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3V5.5h-3Z"
						fill="currentColor"
					/>
				</svg>
			) }
		</a>
	);
};
